import React from "react";
import { Button } from "@src/stories/elements/Button/Button";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";

const ButtonBlock = ({ settings, blocks }) => {
const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
const content_alignment = isMobile ? settings.content_alignment_mobile : settings.content_alignment_desktop;
     
return (
    <div
        className={`buttons-container flex gap-x-[8px] self-${content_alignment}`}
    >
        {blocks.map((block, index) => (
            <div key={block.key || index} className={`pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px]`}>
                {block.settings.button_text && (
                    <Button
                        label={block.settings.button_text}
                        style={block.settings.button_style}
                        link={block.settings.button_url}
                        icon={block.settings.button_icon}
                        onClick={undefined}
                        width={block.settings.button_width}
                    />
                )}
            </div>
        ))}
    </div>
)};

export default ButtonBlock;
